<template>
  <div>
  </div>
</template>

<script>
import store from '@/store'
export default {
  name: 'ForumWidget',
  data: function () {
    return {
      subscription: Object,
      subscriptionNotifications: Object
    }
  },
  computed : {
  },
  methods: {
    initialize: function() {
      var self = this
      this.subscription = this.$cable.subscriptions.create({ channel: 'ForumChannel' }, {
        received: function(data) {
          store.dispatch('addForumUnread')
        }
      })

      this.subscriptionNotifications = this.$cable.subscriptions.create({ channel: 'NotificationChannel' }, {
        received: function(data) {
          if(self.isLoggedIn && self.currentUser.id == data.user_id) {
            if(data.key == 'new_notification') {
              store.dispatch('addNotificationUnread')
              var audio = new Audio('/notification.mp3')
              audio.volume = 0.7
              audio.play()
              self.$notify({
                group: 'all',
                title: 'Você tem uma nova notificação',
                type: 'info',
                duration: -1000
              })
            } else if(data.key == 'lobby_finished') {
              self.$router.push({ name: 'LobbySingle', params: { id: data.lobby_id }})
              store.dispatch('leaveLobby', true)
            } else {
              console.log(data)
            }
          }
        }
      })

      window.addEventListener('beforeunload', function(event) {
        self.subscription.unsubscribe()
        self.subscriptionNotifications.unsubscribe()
      }, false)
    },
  },
  mounted () {
    this.initialize()
  }
}
</script>

<style lang="sass" scoped>
</style>
